import {
  deleteApiCaller,
  getApiCaller,
  postApiCaller,
  putApiCaller,
} from "../apiCaller";

export const getWhisperMusic = async (
  search = "",
  { currentPage = 1, limit = 10, categoryId = undefined } = {}
) => {
  let url = `audio-content/get-all?search=${search}&page=${currentPage}&limit=${limit}&includeHidden=true`;
  if (categoryId !== undefined) {
    url += `&categoryId=${categoryId}`;
  }
  const response = await getApiCaller(url);
  return response;
};

export const postWhisperMusic = async (payload = {}) => {
  const response = await postApiCaller("audio-content/create", payload);
  return response;
};

export const updateWhisperMusic = async (id, payload = {}) => {
  const response = await putApiCaller(`audio-content/${id}`, payload);
  return response;
};

export const deleteWhisperMusic = async (id) => {
  const response = await deleteApiCaller(`audio-content/delete/${id}`);
  return response;
};

export const audioContentSequence = async (payload = {}) => {
  const response = await putApiCaller("audio-content/sequence", payload);
  return response;
};

export const swapAudioContentWithPage = async (payload) => {
  const response = await putApiCaller("audio-content/swap-page", payload);
  return response;
};
